"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodDecorator = void 0;
var react_1 = __importDefault(require("react"));
var Visa_1 = require("./UIComponents/PaymentMethodDecorator/Visa");
var Amex_1 = require("./UIComponents/PaymentMethodDecorator/Amex");
var Discover_1 = require("./UIComponents/PaymentMethodDecorator/Discover");
var Mastercard_1 = require("./UIComponents/PaymentMethodDecorator/Mastercard");
var Stripe_1 = require("./UIComponents/PaymentMethodDecorator/Stripe");
var PayPal_1 = require("./UIComponents/PaymentMethodDecorator/PayPal");
var ApplePay_1 = require("./UIComponents/PaymentMethodDecorator/ApplePay");
var GooglePay_1 = require("./UIComponents/PaymentMethodDecorator/GooglePay");
var Bitcoin_1 = require("./UIComponents/PaymentMethodDecorator/Bitcoin");
var Ethereum_1 = require("./UIComponents/PaymentMethodDecorator/Ethereum");
var PaymentMethodDecorator = function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case "visa":
            return react_1.default.createElement(Visa_1.Visa, null);
        case "amex":
            return react_1.default.createElement(Amex_1.Amex, null);
        case "discover":
            return react_1.default.createElement(Discover_1.Discover, null);
        case "mastercard":
            return react_1.default.createElement(Mastercard_1.Mastercard, null);
        case "stripe":
            return react_1.default.createElement(Stripe_1.Stripe, null);
        case "paypal":
            return react_1.default.createElement(PayPal_1.PayPal, null);
        case "applepay":
            return react_1.default.createElement(ApplePay_1.ApplePay, null);
        case "googlepay":
            return react_1.default.createElement(GooglePay_1.GooglePay, null);
        case "bitcoin":
            return react_1.default.createElement(Bitcoin_1.Bitcoin, null);
        case "ethereum":
            return react_1.default.createElement(Ethereum_1.Ethereum, null);
    }
};
exports.PaymentMethodDecorator = PaymentMethodDecorator;
